import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-icon-schema-management',
  standalone: true,
  templateUrl: './rt-icon-schema-management.component.html',
  styleUrls: ['./rt-icon-schema-management.component.scss']
})
export class RtIconSchemaManagementComponent {
  @Input() width: number | string = 16;
  @Input() height: number | string = 16;
}
